import Loadable from '../../components/loadable';

const SigningWaiverQuestionnaire = Loadable({
  loader: () => import('../../pages/waivers/signing_waivers/signing_waiver_questionnaire'),
});

angular.module('shared').value('SigningWaiverQuestionnaire', SigningWaiverQuestionnaire);
